var map = {
	"./404_bg.svg": "a700",
	"./Gemnote_logo_text_horizontal.svg": "4366",
	"./SalesforceLogo.svg": "e477",
	"./add-white.svg": "9217",
	"./add_icon.svg": "14cb",
	"./alert-icon.svg": "b44a",
	"./am-express-pill.svg": "d3e4",
	"./archive.svg": "119c",
	"./back-arrow-2.svg": "55c2",
	"./back-arrow-bold.svg": "e0bb",
	"./back-arrow.svg": "9e57",
	"./bg.svg": "560b",
	"./billing-icon.svg": "2674",
	"./blog-card-underline.svg": "96de",
	"./broken-image.svg": "6ba8",
	"./broken-link.svg": "c5dd",
	"./check-green-sm.svg": "7017",
	"./check-icon-2.svg": "4e7a",
	"./check-icon.svg": "a0b8",
	"./check.svg": "f222",
	"./checkmark.svg": "0cdd",
	"./circle-check.svg": "cadd",
	"./circle-collapse.svg": "162f",
	"./close-icon.svg": "7ddb",
	"./close-publish.svg": "77b7",
	"./close-x.svg": "0405",
	"./connection.svg": "d114",
	"./copy-icon.svg": "ce6d",
	"./copy.svg": "553b",
	"./course.svg": "e409",
	"./credit-card.svg": "b551",
	"./creditcards/fa_logo.svg": "07f8",
	"./creditcards/mastercard_logo.svg": "2155",
	"./delete-disabled.svg": "b02f",
	"./delete-enabled.svg": "5783",
	"./delivery.svg": "d3e9",
	"./demo-logo.svg": "f284",
	"./discover-pill.svg": "2a66",
	"./download-icon.svg": "e3cc",
	"./download.svg": "6369",
	"./dropdown.svg": "8cc0",
	"./dropdownarrow.svg": "c2c7",
	"./edit-icon.svg": "c3a2",
	"./edit.svg": "6582",
	"./ellipsis.svg": "a16a",
	"./email.svg": "9055",
	"./error-icon.svg": "9b4c",
	"./error-warning.svg": "99b6",
	"./error.svg": "2ee5",
	"./filter-icon.svg": "9673",
	"./flip-horizontal.svg": "f978",
	"./flip-vertical.svg": "d046",
	"./gemnote-back-arrow.svg": "74b2",
	"./gemnote-logo-black.svg": "ee85",
	"./gemnote_logo_and_text.svg": "9dee",
	"./gift-icon-2.svg": "6a14",
	"./gift-icon-3.svg": "e8f2",
	"./gift-icon.svg": "24fd",
	"./gift.svg": "14a1",
	"./google.svg": "0895",
	"./green-tick.svg": "ff25",
	"./guard.svg": "dbae",
	"./home-icon.svg": "45c6",
	"./horizontal-menu.svg": "3b5c",
	"./icon-35.svg": "fc32",
	"./incident.svg": "ffc6",
	"./infinity-icon.svg": "751c",
	"./info-icon.svg": "5d19",
	"./info-warning.svg": "c4f1",
	"./info.svg": "07e6",
	"./input-error.svg": "290e",
	"./integration-icon.svg": "ad76",
	"./inventory-warning.svg": "8fea",
	"./inventory.svg": "e793",
	"./lashes.svg": "4ad0",
	"./left-slider.svg": "a93f",
	"./loading-black.svg": "52b1",
	"./loading-white.svg": "0ecf",
	"./lock.svg": "3c1a",
	"./maintenanceicon.svg": "8e27",
	"./mastercard-pill.svg": "5871",
	"./next-arrow-bold.svg": "e105",
	"./noun_image_trending.svg": "62e0",
	"./order-icon.svg": "305b",
	"./orders-icon.svg": "341b",
	"./password-dark.svg": "9e36",
	"./password.svg": "6005",
	"./plus.svg": "8a37",
	"./pricing-card-underline.svg": "6b8a",
	"./publish.svg": "a933",
	"./rigth-slider.svg": "999a",
	"./rotate-clockwise.svg": "29e9",
	"./rotate-counter-clockwise.svg": "2775",
	"./sales-icon.svg": "d08f",
	"./search.svg": "51f2",
	"./sessions-icon.svg": "3bec",
	"./shipping.svg": "b104",
	"./shopping-bag-big.svg": "8f24",
	"./shopping-bag.svg": "c4b8",
	"./skip-disabled.svg": "691c",
	"./skip-enabled.svg": "8b40",
	"./sort-icon.svg": "003a",
	"./star.svg": "42a8",
	"./stripe-logo.svg": "c1c4",
	"./subtract-white.svg": "a806",
	"./subtract.svg": "5737",
	"./success-check.svg": "ac36",
	"./tip.svg": "28cf",
	"./trash-icon.svg": "19ff",
	"./trash.svg": "c637",
	"./trending-icon.svg": "85c2",
	"./truck-icon.svg": "f878",
	"./trusted-health-patagonia-jacket.svg": "38d8",
	"./upload.svg": "c118",
	"./users-icon.svg": "d730",
	"./users.svg": "c802",
	"./variant_product.svg": "7d3f",
	"./visa-pill.svg": "78f9",
	"./warehouse.svg": "ad11",
	"./warning-2.svg": "64ae",
	"./warning-black.svg": "efe1",
	"./warning-danger.svg": "7c00",
	"./warning-dark.svg": "e803",
	"./warning-icon.svg": "060f",
	"./warning-info.svg": "732c",
	"./warning.svg": "afb7",
	"./x-icon.svg": "db2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";